export const LIST_STATUS = {
  PENDING: '0',
  APPROVED_REJECTED: '1,2',
};

export const REASON_FOR_MISSED_ATTENDANCE = [
  { id: 'Technical Issue', name: 'Technical Issue' },
  { id: 'Missed Marking Attendance', name: 'Missed Marking Attendance' },
];

export const LOCATION_OF_WORK_OPTIONS = [
  { id: 'On Site', name: 'On Site' },
  { id: 'Work From Office', name: 'Work From Office' },
  { id: 'Work Out Of Office', name: 'Work Out Of Office' },
];

export const REGULARIZATION_STATUS = {
  0: { text: 'Pending', className: 'darwin-status-pending' },
  1: { text: 'Approved', className: 'darwin-status-approved' },
  2: { text: 'Rejected', className: 'darwin-status-rejected' },
};

export const REGULARIZATION_PAGE_SIZE = 10;

export const DOCUMENT_UPLOAD_OPTIONS = {
  service_name: 'fusion',
  is_public: true,
  is_view_only: true,
};
